export default "__VITE_ASSET__DhC5P2TF__"